import React, { useEffect } from "react";
import "./style.css";
import {
  Breadcrumb,
  Row,
  Col,
  Avatar,
  Spin
} from "antd";
import {
  EditOutlined,
  SyncOutlined
} from "@ant-design/icons";
import Container from "../Layout/Container";
import { useHistory, useLocation, Link } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSubAdminUser, viewSubAdminSelector, clearState } from './viewSubAdminSlice';
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;


const dashBoardTabOptions = [
  {
    title: 'View Only',
    dataIndex: 'viewOnly',
  },
  {
    title: 'Add Distribution List',
    dataIndex: 'addDistributionList',
  },
  {
    title: 'View Distribution List',
    dataIndex: 'viewDistributionList',
  },
  {
    title: 'Edit Distribution List',
    dataIndex: 'editDistributionList',
  },
  {
    title: 'Delete Distribution List',
    dataIndex: 'deleteDistributionList',
  },
];

const allProcessTabOptions = [
  {
    title: 'View Ongoing Seen Stamp',
    dataIndex: 'viewOnGoingProcess',
  },
  {
    title: 'Create Seen Stamp',
    dataIndex: 'createTemplates',
  },
  {
    title: 'View Seen Stamp Details',
    dataIndex: 'viewTemplates',
  },
  {
    title: 'Manage/edit Seen Stamp',
    dataIndex: 'manage/editTemplates',
  },
];

const branchOptions = [
  {
    title: 'View Branch',
    dataIndex: 'view',
  },
  {
    title: 'Enable/Disable Branch',
    dataIndex: 'enable/disable',
  },
  {
    title: 'Add Branch',
    dataIndex: 'add',
  },

  {
    title: 'edit Branch',
    dataIndex: 'edit',
  },
];

const IndOfficeOptions = [
  {
    title: 'View IO',
    dataIndex: 'view',
  },
  {
    title: 'Enable/Disable IO',
    dataIndex: 'enable/disable',
  },
  {
    title: 'Add IO',
    dataIndex: 'add',
  },

  {
    title: 'edit IO',
    dataIndex: 'edit',
  },
];

const IndDirectorateOptions = [
  {
    title: 'View ID',
    dataIndex: 'view',
  },
  {
    title: 'Enable/Disable ID',
    dataIndex: 'enable/disable',
  },
  {
    title: 'Add ID',
    dataIndex: 'add',
  },

  {
    title: 'edit ID',
    dataIndex: 'edit',
  },
];

// const userRolesTabOptions = [
//   {
//     title: 'View Only',
//     dataIndex: 'viewOnlyRoles',
//   }, 
//   {
//     title: 'Enable/Disable Roles',
//     dataIndex: 'enable/disableRoles',
//   }, 
//   {
//     title: 'Create Roles',
//     dataIndex: 'createRoles',
//   }, 

//   {
//     title: 'edit Roles',
//     dataIndex: 'editRoles',
//   }, 
// ];

const userRolesTabOptions = [
  {
    title: 'View Only',
    dataIndex: 'viewOnlyRoles',
  },
  {
    title: 'Enable/Disable Appointments',
    dataIndex: 'enable/disableRoles',
  },
  {
    title: 'Create Appointments',
    dataIndex: 'createRoles',
  },

  {
    title: 'edit Appointments',
    dataIndex: 'editRoles',
  },
];

const manageUsersTabOptions = [
  {
    title: 'View Only',
    dataIndex: 'viewOnlyUsers',
  },
  {
    title: 'Enable/Disable Users',
    dataIndex: 'enable/disableUser',
  },
  {
    title: 'Create Users',
    dataIndex: 'createUser',
  },
  {
    title: 'edit Users',
    dataIndex: 'editUser',
  },
];




export default function ViewSubAdmin() {

  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [imageUrl, setimageUrl] = React.useState("./images/default-View-SubAdmin-Img.png");

  const { isFetching, isSuccess, isError, errorMessage, response, subadmindata } = useSelector(
    viewSubAdminSelector
  );


  const [dashboardTabList, setdashboardTabList] = React.useState([]);

  const [allProcessTabList, setallProcessTabList] = React.useState([]);

  const [branchList, setbranchList] = React.useState([]);

  const [indOfficeList, setindOfficeList] = React.useState([]);

  const [indDirectorateList, setindDirectorateList] = React.useState([]);

  const [userRolesTabList, setuserRolesTabList] = React.useState([]);

  const [manageUsersTabList, setmanageUsersTabList] = React.useState([]);

  const handleEditClick = () => {
    history.push({
      pathname: '/edit-sub-admin',
      state: { subAdminName: location.state.subAdminName.toLowerCase() }
    });
  }


  useEffect(() => {

    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(fetchSubAdminUser(location.state.subAdminName.toLowerCase()));


  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);

    }

    if (isSuccess) {

      setLoading(false);
      setTimeout(() => {

        if (subadmindata.profilePic.length !== 0) {
          setimageUrl(subadmindata.profilePic);
        }
        else {
          setimageUrl("./images/default-View-SubAdmin-Img.png");
        }

        if (subadmindata.permission) {

          subadmindata.permission.forEach(val => {

            if (val.dashboardTab) {
              let dref = [];
              val.dashboardTab.forEach(deptval => {

                dashBoardTabOptions.find((element) => {
                  if (deptval === element.dataIndex) {
                    dref.push(element.title)
                  }
                })

              });
              setdashboardTabList([]);
              setdashboardTabList(dref);
            }

            if (val.manageB) {
              let dref = [];
              val.manageB.forEach(deptval => {

                branchOptions.find((element) => {
                  if (deptval === element.dataIndex) {
                    dref.push(element.title)
                  }
                })

              });
              setbranchList([]);
              setbranchList(dref);
            }


            if (val.manageIo) {
              let dref = [];
              val.manageIo.forEach(deptval => {

                IndOfficeOptions.find((element) => {
                  if (deptval === element.dataIndex) {
                    dref.push(element.title)
                  }
                })

              });
              setindOfficeList([]);
              setindOfficeList(dref);
            }


            if (val.manageId) {
              let dref = [];
              val.manageId.forEach(deptval => {

                IndDirectorateOptions.find((element) => {
                  if (deptval === element.dataIndex) {
                    dref.push(element.title)
                  }
                })

              });
              setindDirectorateList([]);
              setindDirectorateList(dref);
            }

            if (val.userRolesTab) {
              let dref = [];
              val.userRolesTab.forEach(deptval => {

                userRolesTabOptions.find((element) => {
                  if (deptval === element.dataIndex) {
                    dref.push(element.title)
                  }
                })

              });
              setuserRolesTabList([]);
              setuserRolesTabList(dref);
            }

            if (val.manageUsersTab) {
              let dref = [];
              val.manageUsersTab.forEach(deptval => {
                manageUsersTabOptions.find((element) => {
                  if (deptval === element.dataIndex) {
                    dref.push(element.title)
                  }
                })

              });
              setmanageUsersTabList([]);
              setmanageUsersTabList(dref);
            }

            if (val.allProcessTab) {
              let dref = [];
              val.allProcessTab.forEach(deptval => {
                allProcessTabOptions.find((element) => {
                  if (deptval === element.dataIndex) {
                    dref.push(element.title)
                  }
                })


              });
              setallProcessTabList([]);
              setallProcessTabList(dref);
            }

          });

        }


        setLoading(false);
      }, 1000);

    }

  }, [isError, isSuccess, setLoading, setToast]);



  return (
    <>
      <Container>
        <Breadcrumb
          style={{ margin: "16px 0", paddingLeft: 50, marginBottom: 0 }}
          separator=">"
        >
          <Breadcrumb.Item><Link to="/sub-admin">Sub Admin</Link></Breadcrumb.Item>
          <Breadcrumb.Item>View Sub Admin </Breadcrumb.Item>
        </Breadcrumb>

        <div
          className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>

            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <Row
              style={{
                paddingTop: 35,
                paddingBottom: 20,
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                borderTop: "1px solid #dfe0eb",
                borderBottom: "2px solid #e8e8e8",
                backgroundColor: "#ffffff"
              }}
            >
              <Col span="2"></Col>
              <Col span="19">
                <h1
                  style={{
                    fontWeight: "bold",
                    fontStyle: "normal",
                    fontSize: 24,
                  }}
                >
                  Sub Admin Details
                </h1>
              </Col>
              <Col span="3">
                <h1
                  onClick={handleEditClick}
                  style={{
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: 24,
                  }} > <EditOutlined /> &nbsp;Edit</h1>
              </Col>
            </Row>

            <div className="user-details-page-row-designs"
              style={{
                paddingTop: 35,
                paddingBottom: 20,
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                borderTop: "1px solid #dfe0eb",
                borderBottom: "2px solid #e8e8e8",
                backgroundColor: "#ffffff"
              }}
            >
              <Row style={{ paddingTop: 20, paddingBottom: 20, width: "-webkit-fill-available" }}>
                <Col span="2"></Col>
                <Col span="6">
                  <Avatar src={imageUrl} className="custom-avtar-css" size="large" />
                </Col>
                <Col span="6">
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                    }}
                  >
                    Full Name
                  </p>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {subadmindata && subadmindata.fullName}
                  </p>

                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                      marginTop: 15,
                    }}
                  >
                    Contact No
                  </p>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {subadmindata && subadmindata.phone}
                  </p>
                </Col>
                <Col span="10">
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                    }}
                  >
                    User Name
                  </p>

                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {subadmindata && subadmindata.username}
                  </p>

                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 16,
                      color: "#6B778C",
                      marginBottom: 0,
                      marginTop: 15,
                    }}
                  >
                    Email ID
                  </p>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "normal",
                      fontSize: 22,
                      color: "black",
                      marginBottom: 0,
                    }}
                  >
                    {subadmindata && subadmindata.email}
                  </p>
                </Col>
              </Row>

              <Row
                style={{
                  paddingTop: 20,
                  paddingBottom: 20,
                  width: "-webkit-fill-available"
                }}
              >
                <Col span="2"></Col>
                <Col span="6">
                  <h2 style={{
                    padding: "25px",
                    paddingLeft: "0px",
                    color: "#6b778c",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}>Permissions</h2>
                </Col>
                <Col span="12">

                  <p className="manage-checkbox">Dashboard Tab</p>
                  <div className="mar-l-20 mar-t-15">
                    {dashboardTabList.map(column => {
                      return (
                        <>
                          <span className="mar-r-30 mar-b-20 font-20 d-inline-block">{column}</span>
                        </>
                      )
                    }
                    )
                    }
                  </div>

                  <p className="manage-checkbox">All Seen Stamp Tab</p>
                  <div className="mar-l-20 mar-t-15">
                    {allProcessTabList.map(column => {

                      return (
                        <>
                          <span className="mar-r-30 mar-b-20 font-20 d-inline-block">{column}</span>
                        </>
                      )

                    }
                    )
                    }
                  </div>

                  <p className="manage-checkbox">Department Tab</p>
                  <div className="mar-l-20 mar-t-15">
                    <p className="manage-sub-heading">Branch</p>
                    {branchList.map(column => {
                      return (
                        <>
                          <span className="mar-r-30 mar-b-20 font-20 d-inline-block">{column}</span>
                        </>
                      )
                    }
                    )
                    }

                    <p className="manage-sub-heading">Independent Office</p>
                    {indOfficeList.map(column => {
                      return (
                        <>
                          <span className="mar-r-30 mar-b-20 font-20 d-inline-block">{column}</span>
                        </>
                      )
                    }
                    )
                    }

                    <p className="manage-sub-heading">Independent Directorates</p>
                    {indDirectorateList.map(column => {
                      return (
                        <>
                          <span className="mar-r-30 mar-b-20 font-20 d-inline-block">{column}</span>
                        </>
                      )
                    }
                    )
                    }

                  </div>

                  <p className="manage-checkbox">Appointments Tab</p>
                  <div className="mar-l-20 mar-t-15">
                    {userRolesTabList.map(column => {
                      return (
                        <>
                          <span className="mar-r-30 mar-b-20 font-20 d-inline-block">{column}</span>
                        </>
                      )
                    }
                    )
                    }
                  </div>

                  <p className="manage-checkbox">Manage User Tab</p>
                  <div className="mar-l-20 mar-t-15">
                    {manageUsersTabList.map(column => {
                      return (
                        <>
                          <span className="mar-r-30 mar-b-20 font-20 d-inline-block">{column}</span>
                        </>
                      )
                    }
                    )
                    }
                  </div>

                </Col>
                <Col span="4"></Col>
              </Row>


            </div>

          </div>
        </div>
      </Container>
    </>
  );
}
